import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const handleFocus = (e) => {
    // FORZAR estilos para eliminar azul
    e.target.style.setProperty('border-color', 'rgb(148, 163, 184)', 'important');
    e.target.style.setProperty('outline', 'none', 'important');
    e.target.style.setProperty('box-shadow', 'none', 'important');
  };
  
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-1 text-base text-slate-900 dark:text-white transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-400 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
      style={{ 
        outline: 'none',
        boxShadow: 'none'
      }}
      onFocus={handleFocus}
    />
  );
})
Input.displayName = "Input"

export { Input }
